import { useQueries } from "@tanstack/react-query";
import { BACKEND_URL } from "../config";
import axios from "axios";

const getDomains = (search: string, url: string) => {
    return axios.request({
        url: `${url}/${search}`,
        method: "GET",
    });
};

export const useGetDomains = (search: string, enabled: boolean) => {
    const url = `${BACKEND_URL}/api/v1/domain-check`;

    const topLevelDomains = [".at", ".my.at", ".4.at", ".co.at", ".or.at"];
    return useQueries({
        queries: topLevelDomains.map((top) => ({
            queryKey: [url, search + top],
            queryFn: () => getDomains(search + top, url),
            refetchInterval: Infinity,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            keepData: true,
            enabled: enabled && search !== "" && search.length > 2,
        })),
    });
};
